import { nanoid } from 'nanoid';
import { normalize } from 'normalizr';
import { path } from 'ramda';

import * as schema from 'store/quotes/schema';

import { formatQuoteId } from 'utils/quoteUtils';
import { notify } from 'utils/reduxUtils';

export const types = {
  INIT_DIGIQUOTE: 'digiQuote/digiQuotePage/INIT_DIGIQUOTE',
  INIT_SELECTED_OPTIONS: 'digiQuote/digiQuotePage/INIT_SELECTED_OPTIONS',
  OPEN_CART: 'digiQuote/digiQuotePage/OPEN_CART',
  CLOSE_CART: 'digiQuote/digiQuotePage/CLOSE_CART',
  UPDATE_QUOTE_ITEM_CONFIGRATION:
    'digiQuote/digiQuotePage/UPDATE_QUOTE_ITEM_CONFIGRATION',
  CONFIRM_QUOTE_ITEM_CONFIGURATION:
    'digiQuote/digiQuotePage/CONFIRM_QUOTE_ITEM_CONFIGURATION',
  OPEN_THANK_YOU_MODAL: 'digiQuote/digiQuotePage/OPEN_THANK_YOU_MODAL',
  CLOSE_THANK_YOU_MODAL: 'digiQuote/digiQuotePage/CLOSE_THANK_YOU_MODAL',
  HIDE_QUOTE_INSTRUCTIONS: 'digiQuote/digiQuotePage/HIDE_QUOTE_INSTRUCTIONS',
  REQUEST_A_REQUOTE: 'digiQuote/digiQuotePage/REQUEST_A_REQUOTE',
  REQUEST_A_REQUOTE_ERROR: 'digiQuote/digiQuotePage/REQUEST_A_REQUOTE_ERROR',
  OPEN_SHARE_QUOTE_MODAL: 'digiQuote/digiQuotePage/OPEN_SHARE_QUOTE_MODAL',
  CLOSE_SHARE_QUOTE_MODAL: 'digiQuote/digiQuotePage/CLOSE_SHARE_QUOTE_MODAL',
  SHARE_QUOTE: 'digiQuote/digiQuotePage/SHARE_QUOTE',
  COPY_QUOTE_LINK_REQUEST: 'digiQuote/digiQuotePage/COPY_QUOTE_LINK_REQUEST',
  COPY_QUOTE_LINK_SUCCESS: 'digiQuote/digiQuotePage/COPY_QUOTE_LINK_SUCCESS',
  COPY_QUOTE_LINK_ERROR: 'digiQuote/digiQuotePage/COPY_QUOTE_LINK_ERROR',
  SET_HAS_SUBMITTED: 'digiQuote/digiQuotePage/SET_HAS_SUBMITTED',
  RECEIVE_QUOTE_ITEMS: 'digiQuote/digiQuotePage/RECEIVE_QUOTE_ITEMS',
};

export const initDigiQuote = (payload) => ({
  type: types.INIT_DIGIQUOTE,
  payload: {
    quote: payload,
    quoteId: nanoid(),
    quoteNumberWithRevision: formatQuoteId(payload),
    contactId: path(['contact', 'id'], payload),
    displaySettings: payload.displaySettings,
    showPaperlessBranding: payload.showPaperlessBranding,
    preferredUnitSystem: payload.preferredUnitSystem,
    preferredDateFormat: payload.preferredDateFormat,
  },
});

export const receiveQuoteItems = (payload) => ({
  type: types.RECEIVE_QUOTE_ITEMS,
  payload: {
    ...normalize(payload, [schema.quoteItem]),
  },
});

export const initSelectedOptions = ({ selectedOptions }) => ({
  type: types.INIT_SELECTED_OPTIONS,
  payload: { selectedOptions },
});

export const openCart = () => ({
  type: types.OPEN_CART,
});

export const closeCart = () => ({
  type: types.CLOSE_CART,
});

export const updateQuoteItemConfiguration = ({
  quoteItemId,
  quantityId,
  expediteId,
  addOnCellIds,
}) => ({
  type: types.UPDATE_QUOTE_ITEM_CONFIGRATION,
  payload: { quoteItemId, quantityId, expediteId, addOnCellIds },
});

export const confirmQuoteItemConfiguration = ({ token, params }) => ({
  type: types.CONFIRM_QUOTE_ITEM_CONFIGURATION,
  payload: { token, params },
});

export const thankYouModal = {
  open: () => ({
    type: types.OPEN_THANK_YOU_MODAL,
  }),
  close: () => ({
    type: types.CLOSE_THANK_YOU_MODAL,
  }),
};

export const hideQuoteInstructions = () => ({
  type: types.HIDE_QUOTE_INSTRUCTIONS,
});

export const requestARequote = {
  request: () => ({
    type: types.REQUEST_A_REQUOTE,
  }),
  success: ({ response }) => ({
    type: types.OPEN_THANK_YOU_MODAL,
    payload: { response },
  }),
  error: notify(
    ({ error }) => ({
      type: types.REQUEST_A_REQUOTE_ERROR,
      payload: error,
    }),
    "Can't request a requote",
  ),
};

export const shareQuoteModal = {
  open: ({ digitalQuoteUrl }) => ({
    type: types.OPEN_SHARE_QUOTE_MODAL,
    payload: { digitalQuoteUrl },
  }),
  close: () => ({
    type: types.CLOSE_SHARE_QUOTE_MODAL,
  }),
};

export const shareQuote = () => ({
  type: types.SHARE_QUOTE,
});

export const copyQuoteLink = {
  request: ({ linkInput }) => ({
    type: types.COPY_QUOTE_LINK_REQUEST,
    payload: { linkInput },
  }),
  success: notify(
    () => ({
      type: types.COPY_QUOTE_LINK_SUCCESS,
    }),
    'Quote link successfully copied to the clipboard.',
  ),
  error: notify(
    () => ({
      type: types.COPY_QUOTE_LINK_ERROR,
    }),
    'There was an error while copying. Please copy the link manually.',
  ),
};

export const setHasSubmitted = () => ({
  type: types.SET_HAS_SUBMITTED,
});
